import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ViewPayoutroute from './ViewPayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

export default async function action({ store, params, intl }) {

    const id = params?.id, viewType = params?.type;
    const title = intl?.formatMessage(messages[viewType == 'reservation' ? 'reservationDetails' : 'payoutDetails']);
    let isAdminAuthenticated, adminPrivileges;
    isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    adminPrivileges = store?.getState()?.adminPrevileges?.privileges?.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/viewreservation/', adminPrivileges) && !restrictUrls('/siteadmin/payout', adminPrivileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ViewPayoutroute id={Number(id)} viewType={viewType} /></AdminLayout>,
    };
}